
class MonitoringUtils {
  convertMSToTimeStamp (value) {
    var ms = parseInt((value % 1000))
    var seconds = parseInt((value / 1000) % 60)
    var minutes = parseInt((value / (1000 * 60)) % 60)
    var hours = parseInt((value / (1000 * 60 * 60)) % 24)

    const formater = number => (number < 10) ? '0' + number : number

    ms = ms < 10 ? '00' + ms : (ms < 100 ? '0' + ms : ms)
    seconds = formater(seconds)
    minutes = formater(minutes)
    hours = formater(hours)

    return `${hours}:${minutes}:${seconds}:${ms}`
  }

  changeDate () {
    this.removeDataView()
    this.page = 1
    this.totalRows = 0
    this.findTableData()
  }

  removeDataView () {
    this.showTable = false
    this.listMaster = []
    this.showItem = false
    this.monitoringProcesss = null
  }

  formatDate (dateInfo) {
    const { year, month, day } = (typeof dateInfo === 'string') ? this.stringToDateInfo(dateInfo) : dateInfo
    return `${day}/${month}/${year}`
  }

  stringToDateInfo (source) {
    const year = source.substring(0, 4)
    const month = source.substring(4, 6)
    const day = source.substring(6)
    return { year, month, day, source }
  }

  createDate ({ year, month, day }) {
    return new Date(year, month, day)
  }

  getIconColor (status) {
    const colors = {
      SUCCESS: 'primary',
      ERROR: 'red',
      WARN: 'yellow',
      RUNNING: 'orange'
    }
    return colors[status]
  }

  getIcon (status) {
    const icons = {
      SUCCESS: 'mdi-check-circle-outline',
      ERROR: 'mdi-close-circle-outline',
      WARN: 'mdi-alert-rhombus-outline',
      RUNNING: 'mdi-run-fast'
    }
    return icons[status]
  }

  fillPagination (list, pageSize) {
    const deltaSize = list.length % pageSize
    const diferenceToFullPage = deltaSize === 0 ? 0 : pageSize - deltaSize
    const objectsToFill = Array(diferenceToFullPage).fill({})
    const cloneList = JSON.parse(JSON.stringify(list))

    return list.length !== 0 ? cloneList.concat(objectsToFill) : []
  }
}

export default new MonitoringUtils()
